import { defineMessages } from 'react-intl';

const _default_1: {
	sendButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	stopGeneratingButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	sendButtonLabel: {
		id: 'ai-mate.chat-input.send-button.label',
		defaultMessage: 'Submit',
		description:
			"Button label displayed on the submit/send button in the chat input area of the AI conversation interface. Shown as the text on a button that users click to send their message or prompt to the AI assistant. The purpose is to clearly indicate the action that will be triggered when the button is clicked, which is to submit the user's input and initiate the AI response.",
	},
	stopGeneratingButtonLabel: {
		id: 'ai-mate.chat-input.stop-generating-button.label',
		defaultMessage: 'Stop generating',
		description:
			'Button label displayed on the stop button in the chat input area that appears while the AI assistant is generating a response. Shown as the text on a button that users can click to interrupt and stop the AI response generation in progress. The purpose is to provide users with control to halt the AI response generation at any point during the process.',
	},
});
export default _default_1;
